'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _normalizeUrl = require('normalize-url');

var _normalizeUrl2 = _interopRequireDefault(_normalizeUrl);

var _compactObject = require('./compact-object');

var _compactObject2 = _interopRequireDefault(_compactObject);

var _buildQueryString = require('./build-query-string');

var _buildQueryString2 = _interopRequireDefault(_buildQueryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appendParams = function appendParams(url, cleanParams) {
  if (cleanParams && Object.keys(cleanParams).length) {
    return url + '?' + (0, _buildQueryString2.default)(cleanParams);
  }
  return url;
};

exports.default = function (url, params, options) {
  return (0, _normalizeUrl2.default)(appendParams(url, (0, _compactObject2.default)(params)), options);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/fetch/utils/append-params.js
// module id = 595
// module chunks = 0